<template>
  <div>
    <el-tabs v-model="activeName" class="predictive-tabs">
      <el-tab-pane
          v-for="tab in tabConfigs"
          :key="tab.name"
          :label="tab.label"
          :name="tab.name"
          :lazy="true">
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-card class="box-card" shadow="hover">
                <el-row>
                  <el-table
                      :data="tableData[tab.dataKey]"
                      :height="tab.height"
                      :header-cell-style="tableHeaderStyle"
                      :row-class-name="tableRowClassName">
                    <template v-for="col in tab.columns">
                      <el-table-column
                          v-if="!col.hidden && !col.isAction"
                          :key="col.key"
                          v-bind="col.columnProps">
                      </el-table-column>
                      <el-table-column
                          v-else-if="!col.hidden && col.isAction"
                          :key="col.key + '-action'"
                          :label="col.label">
                        <template slot-scope="scope">
                          <el-button
                              @click="open_detail(scope.row)"
                              type="text"
                              class="action-text-btn"
                              size="small">
                            {{ col.actionLabel }}
                          </el-button>
                        </template>
                      </el-table-column>
                    </template>
                  </el-table>
                </el-row>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { buildAppWebUrl } from '@/utils/appWebUrl';

const API_HOST = process.env.VUE_APP_API_HOST;

const CLINIC_COLUMNS = [
  {
    key: 'index',
    columnProps: {type: 'index', label: '序号', align: 'center'}
  },
  {
    key: 'clinic_id',
    hidden: true,
    columnProps: {prop: 'clinic_id', label: '诊所ID', sortable: true}
  },
  {
    key: 'clinic_name',
    columnProps: {
      prop: 'clinic_name',
      label: '诊所名称',
      sortable: true,
      showOverflowTooltip: true
    }
  },
  {key: 'clinic_phone', columnProps: {prop: 'clinic_phone', label: '电话', sortable: true}},
  {key: 'province', columnProps: {prop: 'province', label: '省份', sortable: true}},
  {key: 'city', columnProps: {prop: 'city', label: '城市', sortable: true}},
  {key: 'area', columnProps: {prop: 'area', label: '地区', sortable: true}},
  {key: 'create_time', columnProps: {prop: 'create_time', label: '最近时间', sortable: true}},
  {
    key: 'action',
    isAction: true,
    label: '操作',
    actionLabel: '详情'
  }
];

const DRUG_COLUMNS = [
  {
    key: 'index',
    columnProps: {
      type: 'index',
      prop: 'order',
      label: '序号',
      width: '120',
      align: 'center'
    }
  },
  {
    key: 'drug_name',
    columnProps: {
      prop: 'drug_name',
      label: '药品名称',
      sortable: true,
      showOverflowTooltip: true
    }
  },
  {key: 'cnt', columnProps: {prop: 'cnt', label: '最近销量', sortable: true}},
  {key: 'drug_hot', columnProps: {prop: 'drug_hot', label: '销量火爆指数', sortable: true}}
];

const TAB_CONFIGS = [
  {name: 'first', label: '云诊所预期消沉列表', dataKey: 'online', height: '600px', columns: CLINIC_COLUMNS},
  {name: 'second', label: 'Pad诊所预期消沉列表', dataKey: 'pad', height: '600px', columns: CLINIC_COLUMNS},
  {name: 'third', label: '药品备货提醒', dataKey: 'drug', height: '600px', columns: DRUG_COLUMNS}
];

const LIST_REQUESTS = [
  {key: 'online', method: 'get', url: '/recent_maybe_absent_clinics_online'},
  {key: 'pad', method: 'get', url: '/recent_maybe_absent_clinics_pad'},
  {key: 'drug', method: 'post', url: '/drug_goods_prepare_alert_list'}
];

export default {
  name: "PredictiveView",
  data() {
    return {
      activeName: "first",
      tabConfigs: TAB_CONFIGS,
      tableData: {
        online: [],
        pad: [],
        drug: []
      },
      tableHeaderStyle: {background: '#363944', color: 'white', border: 'none'}
    }
  },
  mounted() {
    this.fetchAllLists();
  },
  methods: {
    open_detail(row) {
      window.open(
        buildAppWebUrl(`/clinic/clinic_info?doctor_id=-1&clinic_id=${row.clinic_id}`),
        '_blank',
        'noopener,noreferrer'
      );
    },
    fetchAllLists() {
      LIST_REQUESTS.forEach((request) => {
        this.fetchList(request);
      });
    },
    fetchList(request) {
      this.$http[request.method](API_HOST + request.url).then((res) => {
        this.tableData[request.key] = res.data.data;
      })
    },
    tableRowClassName({rowIndex}) {
      return rowIndex % 2 === 1 ? 'warning-row1' : 'success-row1';
    },
  }
}
</script>

<style scoped>
.predictive-tabs {
  margin-top: 10px;
  margin-left: 10px;
}

.action-text-btn {
  color: rgb(46, 205, 129);
}

.el-table /deep/ tbody tr:hover {
  color: black !important
}

.el-table /deep/ .warning-row1 {
  background: #363944;
}

.el-table /deep/ .warning-row1 > td {
  border: none;
}

.el-table /deep/ .success-row1 {
  background: #3C3F4A;
}

.el-table /deep/ .success-row1 > td {
  border: none;
}

.el-card /deep/ .el-card__header {
  border-bottom: none;
  height: 40px;
  padding: 10px 20px;
}

.el-card /deep/ .el-card__body {
  background-color: #363944;
}


/deep/ .el-tabs__item {
  color: white !important;
  font-size: 20px;
}

/deep/ .el-tabs__item.is-active {
  color: white !important;
  font-size: 20px;
}

/deep/ .el-tabs__active-bar {
  background-color: #68F5B9 !important;

}
</style>
